<template>
  <v-footer padless  class="footerCom" v-if="data">
    
      <v-card flat tile width="100%" class="foot pt-4">
        <v-row three-line class="my-d-flex justify-space-around pa-0 ma-0">
          <div class="my-d-flex pa-0 ma-0 align-start">
            <!-- 功能區塊 -->
            <div class="te-left pa-3">

              <!-- 把getInfinity取代掉，因為不需要檢驗特殊符號 -->

              <!-- 標題 -->
              <div class="d-flex justify-start align-center footerContactTitle" v-if="data[1] && data[1].name">
                <a href="#Z" title="下方功能區塊" id="AZ" accesskey="Z" name="Z" class="guide mr-1" >:::</a>
                <p class="pa-0 ma-0 font-h3 font-B" v-html="(t(data[1].name))"></p>
              </div>
              
              <!-- 內容 -->
              <div class="my-d-flex f-left">
                <ul class="myUl myUl2 my-d-flex justify-start pt-1" v-if="data[0] && data[0].menu">
                  <li class="footerMenuFirst" v-for="(item, menuNum) in  data[0].menu" :key="menuNum">
                    <!-- 使用 v-if 检查是否有 ol 项目 -->
                    <template v-if="item.children && item.children.length">
                      <p class="action font-B mb-0" v-html="t(item.name)"></p>
                    </template>

                    <!-- 如果没有 ol 项目，则使用 router-link -->
                    <template v-else>
                      <router-link class="action font-B mb-0"
                        :to="item.link" :title="item.name" v-html="t(item.name)">
                      </router-link>
                    </template>
                   
                    <ol class="footerMenuSecond" v-if="item.children">
                      <li v-for="(child, childIndex) in item.children" :key="childIndex">
                
                        <a  v-if="child.fileName" tabindex="0"
                          :title="`${t(child.name)}`" 
                          class="te-h5"
                          :class="[$store.state.lang == 'zh-CN' || $store.state.lang =='zh-TW' ?'py-2':'py-0']"
                          :href="`${child.link}?tag=${child.name}`"
                          v-html="t(child.name)">
                        </a>

                        <a  v-else
                          :title="`${t(child.name)}`" tabindex="0"
                          class="te-h5"
                          :class="[$store.state.lang == 'zh-CN' || $store.state.lang =='zh-TW' ?'py-2':'py-0']"
                          :href="`${child.link}`"
                          v-html="t(child.name)">
                        </a>

                      </li>
                    </ol>
                  </li>
                </ul>
              </div>
            </div>
            
            <!-- 聯絡我們 -->
            <div class="te-left pa-3">

              <!-- 標題 -->
              <div class="d-flex justify-start align-center footerContactTitle">
                <p class="font-h3 font-B pa-0 ma-0">聯絡我們</p>
              </div>

              <!-- 內容 -->
              <div class="my-d-flex pa-0 ma-0" v-if="data[2]">
                <ul class="myUl myUl2 my-d-flex justify-start">
                  <li class="footerMenuFirst">
                    <ol class="footerMenuSecond pa-0">
                      <li class="contactLi mb-0" v-for="(cp, contactPersonNum) in data[2].contactPerson" :key="contactPersonNum">
                        <div class="d-flex te-left mb-2 justify-start align-center" v-if="cp.name">
                          <div class="icon16 d-flex justify-center align-center">
                            <i class="fa-solid fa-user color-te-w d-flex justify-center align-center"></i>
                          </div>
                          <p class="te-h5 ml-2 color-te-w mb-0">{{ t(cp.name) }}</p>
                        </div>
                        <div class="d-flex te-left mb-3 justify-start align-center" v-if="cp.tel">
                          <div class="icon16 d-flex justify-center align-center">
                            <i class="fa-solid fa-phone color-te-w d-flex justify-center align-center"></i>
                          </div>
                          <p class="te-h5 ml-2 color-te-w mb-0">{{ t(cp.tel) }}</p>
                        </div>
                      </li>
                      <li class="contactLi mb-0">
                        <div class="d-flex justify-start align-center" v-if="data[2].email">
                          <div class="icon16 d-flex justify-center align-center">
                            <i class="fa-solid fa-envelope color-te-w d-flex justify-center align-center"></i>
                          </div>
                          <p class="te-h5 ml-2 color-te-w mb-0" translate="no">{{ data[2].email }}</p>
                        </div>
                      </li>
                      <li class="contactLi mb-0">
                        <div class="d-flex justify-start align-center">
                          <div class="icon16 d-flex justify-center align-center">
                            <i class="fa-solid fa-location-dot color-te-w d-flex justify-center align-center"></i>
                          </div>
                          <p class="te-h5 ml-2 color-te-w mb-0">{{ t(data[2].add) }}</p>
                        </div>
                      </li>
                      <!-- 無障礙A通過標誌 -->
                      <!-- <li class="contactLi mb-0">
                        <div class="d-flex mt-1 justify-start align-center">
                          <a href="https://accessibility.moda.gov.tw/Applications/Detail?category=20231218133051" title="無障礙網站">
                            <img :src="`/tools/img/${data[1].accessibility_logo}`" border="0" width="88" height="31" alt="通過AA檢測等級無障礙網頁檢測" />
                          </a>
                        </div>
                      </li> -->
                    </ol>
                  </li>


                </ul>
              </div>
            </div>
          </div>
        </v-row>

        <v-divider></v-divider>

        <v-card-text class="my-d-flex justify-center" v-if="data[1] && data[1].name">
          <strong class="color-white" v-html="`${(t(data[1].name))} © ${new Date().getFullYear()}`"></strong>
        </v-card-text>
      
      </v-card>

  </v-footer>
</template>

<script>
export default {
  //載入 APP 的資料
  props: ["data"],

  methods:{
  }
};
</script>



<style lang="scss">

.footerCom{
  .v-card{
    background-color: var(--primary) !important;
    color: var(--te-white) !important;
    a{
      color: var(--te-white);
    }
    .theme--light.v-icon{
      color: var(--te-white);
    }
  }
  ul,ol,li{
    padding: 0px 0px;
    padding-left: 0px;
    list-style: none;
  }
}

.myUl{
  padding-left: 0px !important;
  color: var(--nav-te);
  li{
    padding: 8px 12px 12px 12px;
    li{
      padding: 8px 0px 8px;
    }
  }
  ol{
    padding-left: 0px !important;
  }
  .footerMenuSecond{
    padding-top: 4px;
  }
}

.myUl2{
  display: flex;
}
.footerContactTitle{
  padding: 8px 12px;
}
.contact{
  padding-top: 10px !important;
}
.contactLi{
  padding-top: 0px !important;
  // padding-bottom: 16px !important;
}

*[class~="footerMenuFirst"]:hover {
  > a {
    color: var(--primaryLight) !important;
  }
}
*[class~="footerMenuSecond"] li:hover {
  > a {
    color: var(--primaryLight) !important;
  }
}

</style>
